export default __webpack_public_path__ + "static/media/about7.2af2afa3.jpeg";